import { CollectibleId_Schema } from "@/services/collectibles/collectiblesSchema";
import { ParameterElastic_Schema } from "@/services/parameters/parametersSchema";
import { Theme_Schema } from "@/services/themes/themeSchema";
import { CategoryId_Schema } from "@/services/collection/categories";
import { ApiResponse_Image_Schema } from "@/services/images";
import { WholeNumber_Schema } from "@/utilities";
import { z } from "zod";
import { PriceElastic_Schema } from "@/services/prices/priceSchema";

export const CollectibleElastic_Schema = z
  .object({
    collectibleId: CollectibleId_Schema,
    categoryId: CategoryId_Schema,
    name: z.string(),
    theme: Theme_Schema.nullable(),
    images: z.array(ApiResponse_Image_Schema),
    prices: z.record(z.string(), PriceElastic_Schema).transform((price) => Object.values(price)),
    parameters: ParameterElastic_Schema.array(),
    ownedCount: WholeNumber_Schema,
  })
  .transform(({ collectibleId, ...rest }) => ({
    id: collectibleId,
    ...rest,
  }));
